import { render, staticRenderFns } from "./JobPageOverviewInfo.vue?vue&type=template&id=068eeb04&scoped=true&"
import script from "./JobPageOverviewInfo.vue?vue&type=script&lang=js&"
export * from "./JobPageOverviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./JobPageOverviewInfo.vue?vue&type=style&index=0&id=068eeb04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068eeb04",
  null
  
)

export default component.exports